import { render, staticRenderFns } from "./AccountantShell.vue?vue&type=template&id=51bda76c&scoped=true"
import script from "./AccountantShell.vue?vue&type=script&lang=ts"
export * from "./AccountantShell.vue?vue&type=script&lang=ts"
import style0 from "./AccountantShell.vue?vue&type=style&index=0&id=51bda76c&lang=scss&scoped=true"
import style1 from "./AccountantShell.vue?vue&type=style&index=1&id=51bda76c&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bda76c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51bda76c')) {
      api.createRecord('51bda76c', component.options)
    } else {
      api.reload('51bda76c', component.options)
    }
    module.hot.accept("./AccountantShell.vue?vue&type=template&id=51bda76c&scoped=true", function () {
      api.rerender('51bda76c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccountantShell.vue"
export default component.exports